import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";

export enum SortEnum {
  NONE,
  ASCENDING,
  DESCENDING,
}

@Component({
  selector: "app-column-filter",
  templateUrl: "./column-filter.component.html",
  styleUrls: ["./column-filter.component.scss"],
})
export class ColumnFilterComponent implements OnInit, OnChanges {
  @Input() values: any[] = [];
  @Input() initialSelected: any[] = [];
  @Input() template: TemplateRef<{ data: any }>;
  @Input() canSearch: boolean = true;
  @Input() hasEmptyValue: boolean = true;
  @Input() initialSort: SortEnum;
  @Input() ignoredValues: any[];
  @Output() sort = new EventEmitter<SortEnum>();
  @Output() filter = new EventEmitter<any[]>();
  @Output() closePopup = new EventEmitter<void>();

  currentSort = SortEnum.NONE;
  sortEnum = SortEnum;

  selectedValues: any[] = [];
  filteredValues: any[] = [];

  currentFilteredSelection: boolean;
  private _searchFilter: string = "";
  get searchFilter() {
    return this._searchFilter;
  }
  set searchFilter(val: string) {
    this._searchFilter = val;
    this.currentFilteredSelection = false;
    this.filterValues(val);
  }

  private _allSelected: boolean = false;
  get allSelected() {
    return this._allSelected;
  }
  set allSelected(val: boolean) {
    this._allSelected = val;
    this.selectedValues = this._allSelected ? undefined : [];
    this.filter.next(this.selectedValues);
  }

  constructor() {}

  ngOnInit(): void {
    this.filteredValues = this.values.filter(
      (v) => !this.ignoredValues?.includes(v)
    );
    this.selectedValues = this.initialSelected;
    this.checkAllSelected();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialSort?.firstChange) this.currentSort = this.initialSort;
    if (changes.values)
      this.values = this.values.filter(
        (v) => v != undefined && !this.ignoredValues?.includes(v)
      );
    if (changes.values?.firstChange) this.filteredValues = this.values;
    if (changes.initialSelected?.firstChange) {
      this.selectedValues = this.initialSelected;
      this.values = this.values
        .concat(this.selectedValues)
        .filter((v, i, a) => a.findIndex((x) => x == v) == i);
      this.checkAllSelected();
    }
  }

  private checkAllSelected() {
    this._allSelected =
      this.selectedValues == undefined ||
      this.selectedValues.length ==
        this.values.length + (this.hasEmptyValue ? 1 : 0);
    if (this._allSelected) this.allSelected = true;
  }

  setSort(ascending: boolean) {
    if (this.currentSort == SortEnum.NONE)
      this.currentSort = ascending ? SortEnum.ASCENDING : SortEnum.DESCENDING;
    else if (this.currentSort == SortEnum.ASCENDING)
      this.currentSort = ascending ? SortEnum.NONE : SortEnum.DESCENDING;
    else if (this.currentSort == SortEnum.DESCENDING)
      this.currentSort = ascending ? SortEnum.ASCENDING : SortEnum.NONE;
    this.sort.next(this.currentSort);
  }

  filterValues(filter: string = "") {
    this.filteredValues = this.values.filter((v) =>
      v.toString().toLocaleLowerCase().includes(filter.toLocaleLowerCase())
    );
  }

  checkValue(val: any) {
    return this.allSelected || this.selectedValues?.includes(val);
  }
  toggleValue(val: any) {
    if (this.allSelected)
      this.selectedValues = [...this.values].concat(
        this.hasEmptyValue ? undefined : []
      );
    let i = this.selectedValues.findIndex((v) => v == val);
    if (i != -1) {
      this.selectedValues.splice(i, 1);
      this._allSelected = false;
    } else {
      this.selectedValues.push(val);
      this.checkAllSelected();
    }
    this.filter.next(this.selectedValues);
  }
  clearFilters() {
    this.allSelected = true;
    if (this.currentSort != SortEnum.NONE)
      this.setSort(this.currentSort == SortEnum.ASCENDING);
  }
  filterCurrentSelection(close: boolean = false) {
    this.selectedValues = [...this.filteredValues];
    this.currentFilteredSelection = true;
    this.checkAllSelected();
    this.filter.next(this.selectedValues);
    if (close) this.closePopup.next();
  }
}
